import React from "react";


export default function Select(props) {
  return (
    <select
      className="ds-select"
      value={props.value || ''}
      onChange={props.onChange}
    >
      <option value={''} disabled>{props.placeholder}</option>
      {props.children}
    </select>
  )
}


/*

Usage:

<Select placeholder="">
  <option></option>
</Select>

- placeholder: String

*/
